import { ABOUT_CIRCLE_V4_PATH } from "@circle-react/components/NewVersionOptIn/constants";
import { useBackendProps } from "@circle-react/providers/AppContext";
import { useRouteHelpers } from "@circle-react/routes/Main/useRouteHelpers";
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";

import { CommunitySwitcherWithPackageAdapter } from "./CommunitySwitcherWithPackageAdapter";

export const CommunitySwitcher = () => {
  const pathname = useLocation({ select: location => location.pathname });
  const { isSettingsPage, isLivePage, isDiscoverPage } = useRouteHelpers();
  const is2faPage = pathname.startsWith("/two_fa");
  const isPlansPage = pathname.startsWith(settingsNavPathV3.plans.general);
  const isCircleV4AboutPage = pathname.startsWith(ABOUT_CIRCLE_V4_PATH);
  const { display_community_switcher: isDisplayCommunitySwitcherEnabled } =
    useBackendProps();

  const { currentCommunity } = usePunditUserContext();
  const isSubscriptionCancelled = currentCommunity?.subscription_cancelled;
  const shouldDisplayCommunitySwitcherOnPlansPage =
    isSubscriptionCancelled && isPlansPage;

  // Allow community switcher on plans page even though it's a settings page
  const shouldHideCommunitySwitcherOnSettingsPage =
    isSettingsPage && !shouldDisplayCommunitySwitcherOnPlansPage;

  const shouldHideCommunitySwitcher =
    shouldHideCommunitySwitcherOnSettingsPage ||
    is2faPage ||
    isLivePage ||
    isDiscoverPage ||
    isCircleV4AboutPage;

  useEffect(() => {
    const cls = anchorClassNames("has-community-switcher");
    if (!cls) return;
    if (shouldHideCommunitySwitcherOnSettingsPage) {
      document.body.classList.remove(cls);
    } else if (isDisplayCommunitySwitcherEnabled) {
      document.body.classList.add(cls);
    }
  }, [
    pathname,
    shouldHideCommunitySwitcherOnSettingsPage,
    isDisplayCommunitySwitcherEnabled,
    shouldDisplayCommunitySwitcherOnPlansPage,
  ]);

  if (shouldHideCommunitySwitcher) {
    return null;
  }

  return <CommunitySwitcherWithPackageAdapter />;
};
